import ColorPicker from './src/color-picker2.mjs';
export { colorPickerContextKey, colorPickerEmits, colorPickerProps } from './src/color-picker.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElColorPicker = withInstall(ColorPicker);

export { ElColorPicker, ElColorPicker as default };
//# sourceMappingURL=index.mjs.map
